/** Aplica máscara de CNPJ pt-BR: "12345678000190" → "12.345.678/0001-90" */
export const maskCnpj = (value: string): string => {
  const digits = value.replace(/\D/g, "").slice(0, 14);
  return digits
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
};

/** Remove tudo que não for dígito de um CNPJ mascarado. */
export const unmaskCnpj = (masked: string): string => masked.replace(/\D/g, "");
